import { storageService } from "../../services/StorageService.js";

// mutation
export function ADD_TEST_SCHOOLS(state){

  // leaving this code out of production build
  if(process.env.NODE_ENV === "development") {
    state.user_schools=[
      {"url":"fred.schoolsunited.eu","username":"user_1@gmail.com","password":"test","active":0,protocol:"https://"},
      {"url":"fred.schoolsunited.eu","username":"user_2@gmail.com","password":"test","active":0,protocol:"https://"},
      {"url":"fred.schoolsunited.eu","username":"user_3@gmail.com","password":"test","active":0,protocol:"https://"},
      {"url":"fred.schoolsunited.eu","username":"user_4@gmail.com","password":"test","active":0,protocol:"https://"},
      {"url":"fred.schoolsunited.eu","username":"user_0@gmail.com","password":"test","active":0,protocol:"https://"}]
    var user_schools=[...state.user_schools]

    storageService.setItem('user_schools', JSON.stringify(user_schools) );
  }
}